import { useSelector } from 'react-redux';

import { mapMyCompanyAiQueryBuilderAddon } from '../map-my-company-ai-query-builder-addon';

export const useAiQueryBuilderAddon = () => {
  const myCompany = useSelector((state: any) => state.myCompany);
  const { hasAiQueryBuilder } = mapMyCompanyAiQueryBuilderAddon(
    myCompany?.data
  );

  return { hasAiQueryBuilder };
};
